export default __webpack_public_path__ + "static/media/atm.23a0aa1f.svg";